<template>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="p-20">
            <a-form-item label="客户姓名">
                <a-input v-model="dataForm.customer_name" placeholder="客户名称" />
            </a-form-item>
            <a-form-item label="会员状态">
                <a-select v-model="dataForm.enable" placeholder="会员状态" allowClear style="width: 180px;">
                    <a-select-option value="1">有效</a-select-option>
                    <a-select-option value="2">无效</a-select-option>
                    <a-select-option value="3">退会效</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="缴费账户">
                <a-select allowClear v-model="dataForm.account_id" placeholder="请选择" style="width: 160px;">
                    <a-select-option v-for="item in accountList" :key="item.account_id" :value="item.account_id">
                        {{ item.account_name }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="销售">
                <a-select v-model="dataForm.manager_id" style="width: 180px" placeholder="选择负责客户的销售人员"
                    option-label-prop="label" :filter-option="filterOption" showSearch allowClear>
                    <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id" :label="v.real_name">
                        {{ v.real_name }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="入会操作人">
                <a-select v-model="dataForm.user_id" style="width: 180px" placeholder="选择入会操作人"
                    option-label-prop="label" :filter-option="filterOption" showSearch allowClear>
                    <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id" :label="v.real_name">
                        {{ v.real_name }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="是否核对">
                <!-- 核对状态1待核对2核对通过3核对不通过 -->
                <a-select v-model="dataForm.process_status" allowClear style="width: 160px;" placeholder="是否核对">
                    <a-select-option value="1">待核对</a-select-option>
                    <a-select-option value="2">核对通过</a-select-option>
                    <a-select-option value="3">核对不通过</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="交易时间">
                <a-range-picker @change="onChangeTime2" allowClear value-format="yyyy/MM/DD" />
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="getDataList">搜索</a-button>
            </a-form-item>
            <!-- <a-form-item v-permission="['admin:member:create']">
                <a-button type="primary" @click="addOrUpdateHandle({ member_id: '', customer_id })">新增</a-button>
            </a-form-item> -->
            <!-- v-permission="['admin:member:export']" -->
            <a-form-item>
                <a-button type="primary" @click="exportHandle">导出</a-button>
            </a-form-item>
            <a-form-item>
                <a-button @click="batchHedui()" type="primary">批量核对</a-button>
            </a-form-item>
        </a-form>
        <memberTable :columns="columns" :dataList="dataList" :dataListLoading="dataListLoading" :x="2500"
            @addOrUpdateHandle="addOrUpdateHandle" @deleteHandle="deleteHandle" @shoukuanshenhe="shoukuanshenhe"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
        </memberTable>
        <a-pagination class="mt-20 float-right" show-size-changer :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
        <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
        <examine ref="examine" @ok="getDataList"></examine>
    </a-card>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "@/components/Customer/components/memberaddorupdate.vue";
import memberTable from "@/components/Customer/memberTable.vue";
import examine from './examine.vue'
export default {
    mixins: [viewModule],
    components: {
        addorupdate,
        memberTable,
        examine
    },
    data() {
        return {
            selectedRowKeys: [],
            mixinViewModuleOptions: {
                getDataListURL: "/admin/member/page",
                deleteURL: "/admin/member/delete",
                exportURL: "/admin/member/export",
            },
            exportFileName: "会员入会信息导出",
            dataForm: {
                customer_name: "",
                manager_id: undefined,
                user_id: undefined,
                enable: undefined,
                process_status: '1'
            },
            accountList: [],
            columns: [
                {
                    title: "客户姓名",
                    dataIndex: "customer.customer_name",
                    width: 200,
                    align: 'center'
                },
                {
                    title: "客户手机号",
                    dataIndex: "customer.customer_phone",
                    width: 200,
                    align: 'center'
                },
                {
                    title: "会员等级",
                    dataIndex: "vip_key",
                    width: 200,
                    align: 'center'
                },
                {
                    title: "缴费账户",
                    dataIndex: "account.account_name",
                    width: 200,
                    align: 'center'
                },
                {
                    title: "缴费金额",
                    dataIndex: "pay_price",
                    width: 100,
                    align: 'center'
                },
                {
                    title: "缴费时间",
                    dataIndex: "pay_time",
                    width: 200,
                    align: 'center'
                },
                {
                    title: "会员有效性",
                    dataIndex: "enable",
                    width: 120,
                    align: 'center',
                    scopedSlots: { customRender: "enable" },
                },
                {
                    title: "入会福利",
                    dataIndex: "pay_benefit",
                    width: 200,
                    align: 'center',
                    ellipsis: true
                },
                {
                    title: "销售",
                    dataIndex: "customer.managerinfo.user.real_name",
                    width: 160,
                    align: 'center'
                },
                {
                    title: "入会操作人",
                    dataIndex: "user.real_name",
                    width: 120,
                    align: 'center'
                },
                {
                    title: "备注",
                    dataIndex: "remark",
                    width: 200,
                    align: 'center'
                },
                {
                    title: "创建时间",
                    dataIndex: "create_time",
                    width: 200,
                    align: 'center'
                },
                {
                    title: "费用核对状态",
                    dataIndex: "process_status",
                    scopedSlots: { customRender: "process_status" },
                    width: 150,
                    fixed: 'right',
                    align: 'center'
                },
                {
                    title: "操作",
                    scopedSlots: { customRender: "editBtn" },
                    fixed: 'right'
                },
            ],
            userList: []
        };
    },
    mounted() {
        this.$http({
            url: "/admin/account/select",
            method: "get",
        }).then(res => {
            this.accountList = res.data
        })
        this.getUserList()
    },
    methods: {
        batchHedui() {
            if(this.selectedRowKeys.length == 0) return this.$message.error('至少选择一条核对的项')
            this.$refs.examine.init(this.selectedRowKeys)
        },
        onSelectChange(selectedRowKeys) {
            console.log('selectedRowKeys changed: ', selectedRowKeys);
            this.selectedRowKeys = selectedRowKeys;
        },
        getUserList() {
            this.$http({
                url: "/admin/user/page?page=1&limit=200",
                method: "get",
            }).then((res) => {
                this.userList = res.data.result;
            });
        },
        onChangeTime2(e) {
            if (e.length == 2) {
                this.dataForm.pay_start = `${e[0]} 00:00:00`
                this.dataForm.pay_end = `${e[1]} 23:59:59`
            } else {
                this.dataForm.pay_start = undefined
                this.dataForm.pay_end = undefined
            }
        },
        addOrUpdateHandle({ member_id, customer_id, readonly }) {
            this.$refs.addOrUpdate.init({ member_id, customer_id, readonly });
        },
        showView(url) {
            this.$viewerApi({
                images: [url],
            });
        },
        //费用核对
        shoukuanshenhe(external_id) {
            this.$refs.examine.init(external_id)
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
    },
};
</script>

<style></style>